import { render } from "./TransportConfirmation.vue?vue&type=template&id=72ac5d1f&scoped=true"
import script from "./TransportConfirmation.vue?vue&type=script&lang=js"
export * from "./TransportConfirmation.vue?vue&type=script&lang=js"

import "./TransportConfirmation.vue?vue&type=style&index=0&id=72ac5d1f&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ac5d1f"]])

export default __exports__